import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconFine = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 18 18",
	width: 24,
	height: 24,
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 9,
		cy: 8.98,
		r: 5.22,
		fill: "none",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeMiterlimit: 10
	}), /* @__PURE__ */ _jsx("path", {
		d: "M9 15.61V17M13.87 13.85l1.04 1.04M15.61 9H17M13.87 4.11l1.04-1.04M9 2.39V1M4.13 4.11 3.09 3.07M2.39 9H1M4.13 13.85l-1.04 1.04",
		fill: "none",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeMiterlimit: 10
	})]
});
export { SvgIconFine as ReactComponent };
